import styled from 'styled-components/macro'


export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-contect: center;
    align-items: center;
    margin: auto;
    max-width: 80%;
    `;

export const Title = styled.h1`
    width: 100%;
    color: white;
    font-size: 48px;
    text-align: center;
    font-weight: 500;
    `;

export const List = styled.ul`
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    list-style-type: none;

`;

export const Name = styled.p`
    color: #808080;
    text-overflow: ellipsis;
    font-size: 16px;

    &:hover{
        font-weight: bold;
        color:#e5e5e5;
    }
`;


export const Picture = styled.img`
    width: 100%;
    max-width: 150px;
    height: auto;
    border: 3px solid black;
    cursor: pointer;
`;

export const Item = styled.li`
    text-align: center;
    max-height: 200px;
    max-width: 200px;
    margin-right: 30px;
    
    &:hover > ${Picture}{
        border: 3px solid white;
    }
    
    &:hover > ${Name}{
        color: white;
        font-weight: bold;
    }
    
    &: last-of-type{
        margin-right: 0;
    }
`;


